/* eslint-disable */
import React, { useEffect, useRef, useState } from 'react';
import { NavbarLinks } from '../../data/navbar-links';
import { Link, NavLink, useLocation } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';
import { ACCOUNT_TYPE } from '../../utils/constants';
import {
    AiOutlineExclamationCircle,
    AiOutlineHome,
    AiOutlineCloseCircle,
} from 'react-icons/ai';
import ProfileDropDown from '../core/Auth/ProfileDropDown';
import {
    MdKeyboardArrowDown,
    MdKeyboardArrowUp,
    MdGridView,
} from 'react-icons/md';
import Hamburger from 'hamburger-react';
import { FiPhoneCall } from 'react-icons/fi';
import useOnClickOutside from '../../hook/useOnClickOutSide';
import { getAllCategories } from '../../services/operations/courseApi';
import { PiShoppingCartSimpleBold } from 'react-icons/pi';
import { ImSearch } from 'react-icons/im';
import { logOut } from '../../services/operations/authApi';
import DashboardDropDown from '../core/Auth/DashboardDropDown';

const Navbar = () => {
    const [subLinks, setSubLinks] = useState([]);
    const [isOpen, setOpen] = useState(false);
    const [isCategoryOpen, setCategoryOpen] = useState(false);
    const [isSearchOpen, setSearchOpen] = useState(false);

    const { token } = useSelector((state) => state.auth);
    const { user } = useSelector((state) => state.profile);
    const { totalItems } = useSelector((state) => state.wishlist);

    const location = useLocation();
    const ref = useRef(null);
    const ref2 = useRef(null);
    const dispatch = useDispatch();
    useOnClickOutside(ref, ref2, () => setOpen(false));

    const fetchSubLinks = () => {
        dispatch(getAllCategories(setSubLinks));
    };

    useEffect(() => {
        fetchSubLinks();
    }, []);

    const categoryClickHandler = () => {
        isCategoryOpen ? setCategoryOpen(false) : setCategoryOpen(true);
    };

    return (
        <div
            className={`${location.pathname.includes('dashboard')
                || location.pathname.includes('category')
                || location.pathname.includes('course')
                || location.pathname.includes('instructor')
                ? 'bg-richblack-800'
                : 'bg-richblack-900'} fixed top-0 left-0 right-0 z-[51] flex h-14 items-center transition-all duration-200 justify-center border-b border-richblack-700`}
        >
            <div className={`flex justify-between max-w-maxContent items-center w-11/12`}>
                <Link to={'/'} className={`${isSearchOpen ? 'w-[0] -translate-y-16' : 'w-[10.7rem] translate-y-0'} transition-all duration-1000 lg:p-2`}>
                    <div className={`text-[1.7rem] font-semibold text-white`}>StudyNexaa</div>
                </Link>
                <nav className='lg:inline-block hidden min-w-[27.7rem]'>
                    <ul className='flex gap-x-6 text-richblack-25'>
                        {
                            NavbarLinks.map((link, index) => {
                                return (
                                    <li key={index} className='p-1'>
                                        {link.title === 'Category' ? (
                                            <div className='group relative flex items-center justify-center transition-all duration-200'>
                                                <div className='hover:scale-95 transition-all duration-200 flex justify-center items-center gap-x-1 cursor-pointer'>
                                                    <p>{link.title}</p>
                                                    <div className='group bg-white text-richblack-900 rounded-full text-center text-sm font-semibold'>
                                                        <MdKeyboardArrowDown className='group-hover:-rotate-180 transition-all duration-[0.4s]' />
                                                    </div>
                                                </div>
                                                <div className='absolute flex flex-col top-10 bg-white left-[0.73rem] px-5 py-2 transition-all duration-200 origin-bottom max-w-maxContent w-[17rem] rounded-md invisible opacity-0 group-hover:visible group-hover:opacity-100 group-hover:translate-y-0'>
                                                    <div className='bg-white -z-10 w-6 h-6 rotate-[45deg] absolute -top-2 left-[3.3rem]'></div>
                                                    {
                                                        subLinks.length ? (
                                                            subLinks.map((link, index) => (
                                                                <Link key={index} to={`/category/${link.name.toLowerCase()}`} className='my-[2px]'>
                                                                    <div className='text-richblack-500 max-w-maxContent px-5 w-full py-1 font-semibold hover:bg-richblack-50 rounded-lg cursor-pointer'>
                                                                        {link.name}
                                                                    </div>
                                                                </Link>
                                                            ))
                                                        ) : (
                                                            <div className={`origin-top transition-all duration-500 flex flex-col gap-4 py-2`}>
                                                                <div className='loader'></div>
                                                                <div className='loader'></div>
                                                                <div className='loader'></div>
                                                            </div>
                                                        )
                                                    }
                                                </div>
                                            </div>
                                        ) : (
                                            <NavLink className={'hover:text-yellow-25'} to={link?.path}>
                                                <p className='hover:scale-95 transition-all duration-200'>{link.title}</p>
                                            </NavLink>
                                        )
                                        }
                                    </li>
                                )
                            })
                        }
                    </ul>
                </nav>
                <div className='flex items-center gap-x-1 sm:gap-x-4'>
                    {token === null &&
                        <div className={`${isSearchOpen ? 'w-[0rem]' : 'w-[10.5rem]'} transition-[width] origin-bottom-right justify-between duration-1000 lg:flex hidden items-center`}>
                            <Link to={'/login'} className={`${isSearchOpen ? '-translate-y-56' : 'translate-y-0'} origin-bottom transition-all duration-1000`}>
                                <button className={`bg-richblack-800 py-2 px-3 text-richblack-100 border border-richblack-700 min-w-[4.35rem] rounded-lg hover:scale-95`}>
                                    Log in
                                </button>
                            </Link>
                            <Link to={'/signup'} className={`${isSearchOpen ? '-translate-y-56' : 'translate-y-0'} origin-bottom transition-all duration-1000`}>
                                <button className={`bg-richblack-800 p-2 px-3 text-richblack-100 border border-richblack-700 min-w-[5.05rem] rounded-lg hover:scale-95`}>
                                    Sign up
                                </button>
                            </Link>

                        </div>
                    }
                    <div
                        className={`${isSearchOpen ? 'py-[2px] px-1 pl-5 gap-x-2 lg:w-[35vw] w-[80vw]' : 'w-[2rem]'} transition-all duration-[1s] mx-auto text-richblack-5 bg-richblue-400 rounded-full flex items-center`}
                    >
                        <input
                            type='search'
                            name='search-bar'
                            id='search-bar'
                            className={`${isSearchOpen ? 'w-full opacity-100' : 'opacity-0 w-0'} transition-all duration-1000 bg-transparent font-bold text-richblack-50`}
                            placeholder='Search...'
                        />
                        <button
                            type='button'
                            className='bg-richblue-600 w-8 min-w-[2rem] h-8 rounded-full flex items-center justify-center transition-all duration-1000'
                            onClick={() => setSearchOpen(!isSearchOpen)}
                        >
                            <ImSearch className={`${isSearchOpen ? 'opacity-0 rotate-90' : 'opacity-100'} absolute transition-all duration-1000`} />
                            <AiOutlineCloseCircle className={`${isSearchOpen ? 'opacity-100 rotate-90' : 'opacity-0'} absolute transition-all font-extrabold text-lg duration-1000`} />
                        </button>
                    </div>
                    {token !== null &&
                        <div className='lg:flex hidden w-[5.65rem] gap-x-1 items-center'>
                            {user && user?.accountType === ACCOUNT_TYPE.STUDENT && (
                                <Link to={'/dashboard/wishlist'} className='group relative'>
                                    <PiShoppingCartSimpleBold className=' text-richblack-200 text-[22px] mr-4 transition-all duration-200 group-hover:scale-[1.04]' />
                                    {totalItems > 0 && (
                                        <span className='text-yellow-100 absolute -top-[7px] right-[9px] -z-10 grid h-4 w-4 place-items-center overflow-hidden rounded-full bg-richblack-600 text-center text-[0.65rem] font-bold transition-all duration-200 group-hover:scale-[1.04]'>
                                            {totalItems}
                                        </span>
                                    )
                                    }
                                </Link>
                            )}
                            {token !== null && <ProfileDropDown />}
                        </div>
                    }
                    <nav className={`${isSearchOpen ? 'w-[0rem]' : 'w-[3rem]'} transition-[width] origin-bottom-right duration-1000 lg:hidden inline-block`}>
                        <div ref={ref} onClick={() => isOpen ? setOpen(false) : setOpen(true)} className={`${isSearchOpen ? '-translate-y-56' : 'md:-translate-y-1 -translate-y-[6px]'} origin-bottom transition-all duration-1000 text-white md:scale-y-[0.85] scale-[0.75]`}>
                            <Hamburger toggled={isOpen} className={`focus:bg-none z-50`} />
                        </div>
                        {isOpen && (
                            <div ref={ref2} onClick={(e) => e.stopPropagation()} className={`${isOpen ? 'h-full' : 'h-0 invisible'} w-[13rem] flex fixed top-14 right-0 bg-richblack-900 z-[100] justify-start items-center transition-all duration-[10s] flex-col overflow-hidden border-l border-b border-richblack-700`}>
                                <div className={`${isOpen ? 'opacity-100' : 'opacity-0'} flex flex-col gap-4 justify-center ${!token ? 'items-center' : 'pl-4'} border-b-4 border-richblack-700 w-full py-4 transition-all duration-[0.3s] ease-in`}>
                                    {token === null && (
                                        <Link onClick={() => setOpen(false)} to={'/login'}>
                                            <button className={`bg-richblack-800 py-2 px-3 w-[10rem] text-richblack-100 border border-richblack-700 rounded-lg hover:scale-95`}>
                                                Log in
                                            </button>
                                        </Link>
                                    )}
                                    {token === null && (
                                        <Link onClick={() => setOpen(false)} to={'/signup'}>
                                            <button className={`bg-richblack-800 p-2 px-3 w-[10rem] text-richblack-100 border border-richblack-700 rounded-lg hover:scale-95`}>
                                                Sign up
                                            </button>
                                        </Link>
                                    )}
                                    {token !== null && user && (
                                        <div className='text-richblack-5'>
                                            <DashboardDropDown setOpen={setOpen} user={user} logOut={logOut} />
                                        </div>
                                    )}
                                </div>
                                <div className={`${isOpen ? 'opacity-100' : 'opacity-0'} flex flex-col text-richblack-5 gap-10 text-lg mt-7 pl-4 transition-all duration-[0.6s]`}>
                                    {NavbarLinks.map((link, index) => (
                                        link.title === 'Category' ? (
                                            <div key={index} onClick={categoryClickHandler}>
                                                <div className='hover:scale-95 transition-all duration-200 flex flex-row-reverse justify-end items-center gap-x-3 cursor-pointer'>
                                                    {link.title}
                                                    <div className='text-richblack-5 border rounded-full text-center text-sm font-semibold'>
                                                        {isCategoryOpen ? <MdKeyboardArrowUp className='rotate-[360deg] transition-all duration-300' /> : <MdKeyboardArrowUp className='rotate-180 transition-all duration-300' />}
                                                    </div>
                                                </div>
                                                <div>
                                                    {subLinks.length ? (
                                                        <div className={`${isCategoryOpen ? `scale-y-100` : 'scale-y-0 h-0'} origin-top transition-all duration-500 overflow-hidden`}>
                                                            {subLinks.map((link, index) => (
                                                                <Link key={index} onClick={() => setOpen(false)} to={`/category/${link.name.toLowerCase()}`}>
                                                                    <div className='text-richblack-300 max-w-maxContent px-2 text-center w-[9rem] py-[0.4rem] overflow-hidden font-semibold hover:border border-richblack-700 rounded-lg cursor-pointer mt-3'>
                                                                        {link.name}
                                                                    </div>
                                                                </Link>
                                                            ))}
                                                        </div>
                                                    ) : (
                                                        <div className={`${isCategoryOpen ? `scale-y-100 h-14` : 'scale-y-0 h-0 hidden'} origin-top pt-2 transition-all duration-500`}>
                                                            <div className='loader transition-all duration-500'></div>
                                                        </div>
                                                    )}
                                                </div>
                                            </div>
                                        ) : (
                                            <NavLink onClick={() => setOpen(false)} key={index} to={link?.path}>
                                                {link.title === 'Home' ? (
                                                    <p className='hover:scale-95 transition-all duration-200 flex items-center gap-3'>
                                                        <AiOutlineHome />
                                                        {link.title}
                                                    </p>
                                                ) : link.title === 'Feed' ? (
                                                    <p className='hover:scale-95 transition-all duration-200 flex items-center gap-3'>
                                                        <MdGridView />
                                                        {link.title}
                                                    </p>
                                                ) : (
                                                    link.title === 'About Us' ? (
                                                        <p className='hover:scale-95 transition-all duration-200 flex items-center gap-3'>
                                                            <AiOutlineExclamationCircle />
                                                            {link.title}
                                                        </p>
                                                    ) : (
                                                        link.title === 'Contact Us' ? (
                                                            <p className='hover:scale-95 transition-all duration-200 flex items-center gap-3'>
                                                                <FiPhoneCall />
                                                                {link.title}
                                                            </p>
                                                        ) : (
                                                            <p className='hover:scale-95 transition-all duration-200'>{link.title}</p>
                                                        )
                                                    )
                                                )}
                                            </NavLink>
                                        )
                                    ))}
                                </div>
                            </div>
                        )}
                    </nav>
                </div>
            </div>
        </div>
    )
}

export default Navbar;